module.exports = __webpack_public_path__ + "img/calendar_blue.cc8ea5e2.svg";